/**
 * Component: AssetList.jsx
 * Description: This component is utilized for Listing the all asset in the grid with Edit,Delete and View buttons.
 */

import styled from "@emotion/styled";
import { Box, Button, Grid, Paper, Typography, Stack } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import {
  clearAttachmentDetails,
  gridValues,
  mandatoryFields,
  serviceType,
  updateAssetSpecification,
  updateBasicDetails,
  updatePurchaseDetails,
} from "../../redux/actions/assetActions";
import AssetRepository from "../../api/repositories/assetRepository";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CustomDialog from "../commoncomponents/CustomDialog";
import PageTitle from "../commoncomponents/PageTitle";
import CloseButton from "../commoncomponents/CloseButton";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import PageLoader from "../commoncomponents/PageLoader";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';

const AssetList = () => {
  const location = useLocation();
  const { code, service } = location.state || "";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [workGroupdetail, setWorkGroupDetail] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [workGroup, setWorkGroup] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({});
  const [activeCard, setActiveCard] = useState({
    all: true
  });
  const [gridLoader, setGridLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)

  const [assetTotalCount, setAssetTotalCount] = useState(0)

  const assetCategoryType = useSelector(
    (state) => state?.serviceType?.assetType
  );
  //To get the URL path to classfy the Asset type
  const url = window.location.pathname;
  dispatch(serviceType(url));
  const [wgCode, setWgCode] = useState('');

  useEffect(() => {
    if (location.state && code) {
      handleAssetCardClick(code);
    }
    else if (workGroup?.length > 0 && !activeCard?.all) {
      handleAssetCardClick(wgCode); //changes
    }

  }, [code, workGroup, filterModel, sortModel, pageIndex, pageSize, assetCategoryType]);


  // default values for basic details
  const intialBaiscDetails = {
    rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
    tcNo: "",
    tcOldNo: "",
    assetClassification: {
      key: "option1",
      id: 1,
      label: "Asset",
      isloanerasset: false,
    }, //setting the default value for asset classification when rentalStatus is No
    financeAssetNo: "",
    assetDescription: "",
    typecode: "",
    typeCodeDescription: "",
    locationName: "",
    locationNo: "",
    userDepartment: "",
    departmentDescription: "",
    criticality: "",
    workGroup: "",
    ppmRequired: { label: "Yes", key: "option1", default: true }, //setting the default value
    ppmStatus: { label: "In House", key: "option2", isvisible : true,id: 2 },
    parentAssestNo: "",
    description: "",
    reason: "",
    isauthorized: false,
    assetValue: "",
    oldAssetNo: "",
    id: "",
  };

  // default values for asset specification
  const initailAssetSpecification = {
    make: "",
    brand: "",
    model: "",
    serialNo: "",
    version:"",
    engineNo: "",
    chassisNo: "",
    manufacturer: "",
    registrationNo: "",
    capacity: "",
    assetStatus: { id: 1, label: 'Functioning ', isvisible: true },
    lifeSpan: "",
    depreciationValue: "",
    buildupArea: "",
    footPrint: "",
    landArea: "",
    isDataSetInEditMode: false,
  };

  // default values for purchase details
  const initialPurchaseDetails = {
    warrantyStartDate: "",
    warrantyEndDate: "",
    commissioningDate: "",
    warranty: "",
    vendor: "",
    purchaseOrderNo: "",
    purchaseCost: "",
    accessories: "",
    cumulativePartCost: null,
    cumulativeLabourCost: null,
    lastUnscheduledWorkOrder: "",
    lastScheduledWorkOrder: "",
    assetTransferCategory: "",
    purchaseFlag: "",
    assetTransferDepartment: "",
    underWarrenty: false,
    isDataSetInEditMode: false,
    isTCFieldSet: false,
  };

  const initialAttachmentDetails = [];

  const isFems = assetCategoryType === "/assetsFEM"

  const accessDataFem = useAccess();
  const accessFem = utilities.getScreenPermissions(accessDataFem, "ENGM013");
  const accessDataBem = useAccess();
  const accessBem = utilities.getScreenPermissions(accessDataBem, "ENGM014");

  const setInitialValuesForAllPages = () => {
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(
      updateAssetSpecification(
        "UPDATE_ASSET_SPECIFICATION",
        initailAssetSpecification
      )
    );
    dispatch(
      updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", initialPurchaseDetails)
    );
    dispatch(
      clearAttachmentDetails(
        "CLEAR_ATTACHMENT_DETAILS",
        initialAttachmentDetails
      )
    );
  };

  //To get the facility ID from Local storage
  const facilityId = getFacilityId("facilityId");

  // Fetch the Grid Values from API
  const fetchData = async (assetType, pageIndex, pageSize, filterModel, sortModel) => {
    try {
      setGridLoader(true);
      const response = await AssetRepository.assetListing(assetType, pageIndex, pageSize, filterModel, sortModel);
      setRows(response?.items);
      setFilteredRows(response?.items);
      setRowCount(response?.totalCount);
      setAssetTotalCount(response?.assetTotal)
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    } finally {
      setGridLoader(false);
    }
  };

  //Fetch the Work Group Code from API
  const WorkGroupCode = async (assetType, id) => {
    try {
      const response = await AssetRepository.workGroupCodeDetails(
        assetType,
        id
      );
      setWorkGroup(response);
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    }
  };

  const handleSwitchChange = () => {
    // Access the checked state of the switch using event.target.checked
    // Perform actions based on the switch state (isChecked)
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
  };

  useEffect(() => {
    if (activeCard?.all) {
      fetchData(assetCategoryType, pageIndex, pageSize, filterModel, sortModel);
    }
  }, [filterModel, sortModel, pageIndex, pageSize, assetCategoryType])

  useEffect(() => {
    handleSwitchChange();
    gridApi?.setFilterModel('');
    setActiveCard({ all: true });
    setErrorMessage("");
    setRowToDelete({});
    setDeleteDialogOpen(false);
    setWorkGroupDetail([]);
    setWorkGroup([]);
    setRows([]);
    setFilteredRows([]);
    // fetchData(assetCategoryType);
    WorkGroupCode(assetCategoryType, facilityId);
    setInitialValuesForAllPages();
    handleAssetCardClick();
    //for pagination
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([]);
    setSortModel([]);
  }, [assetCategoryType]);

  // AssetCard  for display diffrent types for workgroup details
  const AssetCard = styled(Box)(({ theme }) => ({
    display: "grid",
    maxWidth: "1200px",
    gridTemplateColumns: "repeat(6,1fr)",
    gap: "8px",
    "@media screen and (max-width: 1200px)": {
      gridTemplateColumns: "repeat(4, 1fr)",
    },
    "@media screen and (max-width: 780px)": {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
    "@media screen and (max-width: 700px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media screen and (max-width: 550px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
  }));

  // Each WorkGroupCode CardItem
  const AssetCardItem = styled(Paper)(({ theme }) => {
    return {
      backgroundColor: "background.paper",
      boxShadow: "none",
      border: "1px solid #EFEEF0",
      minHeight: "100px",
      cursor: "pointer",
      display: "inline-flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "16px",
      borderRadius: "0px",
      "&>p,&>h2": {
        fontSize: "12px",
        margin: 0,
        marginTop: "auto",
      },
      "&.active": {
        backgroundColor: theme.palette.primary.hover,
      },
      "&:not(.active):hover": {
        backgroundColor: theme.palette.primary.hover,
        "& .MuiTypography-h2": {
          color: theme.palette.primary.main,
        },
      },
    };
  });

  // Asset List Grid Field Values
  const columnNames = [
    { field: "assetNo", headerName: "Asset No" },
    { field: "assetDescription", headerName: "Asset Description" },
    { field: "assetClassificationCode", headerName: "Asset Classification" },
    { field: "workgroup", headerName: "Work Group" },
    { field: "assetTypeCode", headerName: "Asset Type Code" },
    { field: "oldassetno", headerName: "Old Asset No" },
    { field: "userLocationCode", headerName: "Location Code" },
    { field: "userDepartmentCode", headerName: "Department Code" },
    { field: "userDescription", headerName: "Department Description" },
    { field: "status", headerName: "Asset Status" },
    //{ field: "ppmstatus", headerName: "PPM Status" },
    { field: "model", headerName: "Model" },
    { field: "serialNumber", headerName: "Serial Number" },
    { field: "manufacturer", headerName: "Manufacturer" },
    {
      field: "authorizedStatus",
      headerName: "Status",
      cellRenderer: (params) => {
        if (params?.value === "Authorized") {
          return <SuccessChips label={params.value} />;
        } else if (params?.value === "UnAuthorized") {
          return <ErrorChips label={params.value} />;
        }
      },
    },
  ];

  // Navigate to Create a new AssetRegister page
  const handleAssetRegister = () => {
    const isAssetCreation = true; //this flag for showing the underwarranty
    const mergedPurchaseDetails = {
      ...initialPurchaseDetails,
      isAssetCreation,
    };
    // setting initial values to asset register page
    dispatch(gridValues({ values: {}, isEdit: false, isView: false }));
    dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
    dispatch(
      updateAssetSpecification(
        "UPDATE_ASSET_SPECIFICATION",
        initailAssetSpecification
      )
    );
    dispatch(
      updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails)
    );
    dispatch(
      clearAttachmentDetails(
        "CLEAR_ATTACHMENT_DETAILS",
        initialAttachmentDetails
      )
    );
    navigate(`${assetCategoryType}/registration`, { state: { assetMode: "Create" } });
  };

  //Set the grid value filtered by workgroup id
  const filteredworkGroup = async (assetType, workgroupid, pageIndex, pageSize) => {
    setGridLoader(true);
    const checkFemorBem = assetCategoryType === "/assetsFEM" ? "fem" : "bem";
    try {

      const response = await AssetRepository.workgroupFilteredRows(
        assetType,
        workgroupid,
        filterModel, sortModel, pageIndex, pageSize
      );
      if (response) {
        setFilteredRows(response?.[0]?.[`${checkFemorBem}assetregisters`]);
        setRowCount(response?.[0]?.assetCount)
      }
    } catch (error) {
      console.error("Failed to fetch filtered work group data:", error);
    } finally {
      setGridLoader(false);
    }
  };

  const fetchWorkGroupData = async (workgroupid) => {
    try {
      setIsLoading(true);
      const checkFemorBem = assetCategoryType === "/assetsFEM" ? "fem" : "bem";
      const response = await AssetRepository.exportDataForWorkGroup(
        assetCategoryType,
        workgroupid,
        filterModel, sortModel
      );
      setExportData(response[0]?.[`${checkFemorBem}assetregisters`]);

    } catch (error) {
      console.error("Failed to fetch filtered work group data:", error);
    }finally{
      setIsLoading(false);
    }
  };


  // Fetch the Grid Values from API
  const fetchExportData = async () => {
    try {
      setIsLoading(true);
      const response = await AssetRepository.exportData(assetCategoryType, filterModel, sortModel);
      setExportData(response?.data);
    } catch (error) {
      console.error("Failed to fetch asset data:", error);
    }finally{
      setIsLoading(false);
    }
  };

  const handleExportData = async () => {
    if (wgCode) {
      await fetchWorkGroupData(workGroupdetail?.id);
    } else {
      await fetchExportData();
    }
  };

  // Edit the Asset listing page
  const viewAssetApi = async (id) => {
    try {
      setIsLoading(true);
      const response = await AssetRepository.assetViewDetail(
        assetCategoryType,
        id
      );
      return response;
    } catch (error) {
      console.error("Fail to get the asset", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle Edit Page from the assetList grid table
  const handleEdit = async (data, type) => {
    let Edit = type === "Edit" ? true : false;
    try {
      const editAssetbyId = await viewAssetApi(data?.assetId);
      const isAssetCreation = false; //this flag for not showing the underwarranty
      const mergedPurchaseDetails = { ...initialPurchaseDetails, isAssetCreation };
      const mergerowData = { ...editAssetbyId, timestamp: data?.timestamp || "" }
      if (editAssetbyId) {
        dispatch(gridValues({ values: mergerowData, isEdit: Edit, isView: !Edit }));
        dispatch(updateBasicDetails("UPDATE_BASIC_DETAILS", intialBaiscDetails));
        dispatch(updateAssetSpecification("UPDATE_ASSET_SPECIFICATION", initailAssetSpecification));
        dispatch(updatePurchaseDetails("UPDATE_PURCHASE_DETAILS", mergedPurchaseDetails));
        dispatch(clearAttachmentDetails("CLEAR_ATTACHMENT_DETAILS", initialAttachmentDetails));
        navigate(`${assetCategoryType}/registration`, { state: { ...data, id: data?.assetId, type: "Edit", assetMode: "Edit" } });
      } else {
        setIsError(true)
      }
    } catch (error) {
      setIsError(true)
      console.error("Fail to get the asset", error);
    }
  };

  // Handle the aseet View page from the assetList grid table
  const handleView = async (data, type) => {
    let View = type === "View" ? true : false;
    const viewAssetbyId = await viewAssetApi(data?.assetId);
    if (viewAssetbyId) {
      dispatch(gridValues({ values: viewAssetbyId, isEdit: !View, isView: View, updatedRows: rows, }));
      navigate("view", { state: { id: data?.assetId, type: "View", values: viewAssetbyId, isEdit: !View, isView: View, updatedRows: rows, assetCategoryType } });
    } else {
      setIsError(true);
    }
  };

  // Handle Delete Page from the assetList grid table
  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  // Confirm Delete the asset from the assetList grid table
  const confirmDelete = async () => {
    let assetType;
    let checkFemorBem;
    if (assetCategoryType === '/assetsFEM') {
      assetType = FemsGraph;
      checkFemorBem = "fem";
    } else if (assetCategoryType === '/assetsBEM') {
      assetType = BemsGraph;
      checkFemorBem = "bem";
    } else {
      return;
    }
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (!rowToDelete || !rowToDelete?.assetId) {
        return;
      }
      await axios.delete(
        `${assetType}/api/${checkFemorBem}assetregisters/${rowToDelete?.assetId}`,
        config
      );
      const updatedRows = rows.filter(
        (row) => row?.assetId !== rowToDelete?.assetId
      );
      setFilteredRows(updatedRows);
    } catch (error) {
      if (error?.response && error?.response?.status === 400) {
        // Assuming 409 is the status code for "Conflict"
        setErrorMessage("The Asset Code  is Already in use");
      } else {
        setErrorMessage(
          "An error occurred while deleting the asset. Please try again."
        );
      }
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete({});
    }
  };
  // Handle Asset Card Click
  const handleAssetCardClick = async (wgCode) => {
    if (wgCode) {
      setWgCode(wgCode)
      let serviceType = service ? service : assetCategoryType
      const response = await AssetRepository.workGroupCodeDetails(
        serviceType,
        facilityId
      );

      const selectedGroup = response?.find(
        (item) => item?.wgcode === wgCode
      );

      let pageindex = pageIndex;
      let pagesize = pageSize;

      setWorkGroupDetail(selectedGroup);
      setActiveCard({
        [selectedGroup?.wgcode]: true, //set the workgroup code active when the user click the workgroup
      });
      await filteredworkGroup(assetCategoryType, selectedGroup?.id, pageindex, pagesize);
    } else {
      setFilteredRows(rows);
      setActiveCard({
        all: true,
      });
      setWorkGroupDetail([]);
      setWgCode(null);
      fetchData(assetCategoryType, pageIndex, pageSize, filterModel, sortModel);
    }
  };

  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([]);
    setSortModel([]);
    setActiveCard((prev) => {
      return Object.entries(prev).reduce(
        (updatedPrev, [key, value]) => {
          if (value) {
            updatedPrev[key] = false;
            updatedPrev["all"] = true;
          }
          return updatedPrev;
        },
        {}
      );
    });
    setWorkGroupDetail([]);
  };

  return (
    <>
      <PageLoader open={isLoading} />
      <PageTitle
        title={
          assetCategoryType === "/assetsFEM"
            ? "Asset Register - FEMS"
            : "Asset Register - BEMS"
        }
      />
      <Box mt={{ xs: 1, sm: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <DefaultCard>
              <AssetCard>
                <AssetCardItem
                  className={activeCard?.all ? "active" : " "}
                  sx={{ padding: { xs: 1, md: 2 } }}
                  onClick={() => handleAssetCardClick()}
                >
                  <Typography fontWeight="bold">All Assets</Typography>
                  <Typography variant="h2">{assetTotalCount}</Typography>
                </AssetCardItem>
                {workGroup &&
                  workGroup?.length > 0 &&
                  workGroup
                    .sort((a, b) => {
                      const matchWgCode = a.wgcode?.match(/\d+/); // Check the work group code
                      const matchWgDescription = b.wgcode?.match(/\d+/); // check the workgroupdescription
                      const wgCode = matchWgCode
                        ? parseInt(matchWgCode[0], 20)
                        : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
                      const wgDescription = matchWgDescription
                        ? parseInt(matchWgDescription[0], 20)
                        : Number.MAX_SAFE_INTEGER; // Assign a high value if no digits
                      return wgCode - wgDescription;
                    })
                    .map((wg) => (
                      <AssetCardItem
                        key={wg?.wgcode}
                        className={activeCard[wg.wgcode] ? "active" : ""}
                        sx={{ padding: { xs: 1, md: 2, sm: 2 } }}
                        onClick={() => handleAssetCardClick(wg.wgcode)}
                        data-testid="Asset-card-items"
                      >
                        <Typography fontWeight="bold">
                          {wg?.wgcode} - {wg?.wgdesc}
                        </Typography>
                        <Typography variant="h2">
                          {wg?.assetCount || 0}
                        </Typography>
                      </AssetCardItem>
                    ))}
              </AssetCard>
            </DefaultCard>
          </Grid>
        </Grid>
      </Box>
      {/* data grid */}
      <Box mt={{ xs: 1, sm: 2 }}>
        <DefaultCard>
          <Box>
            <Stack
              mb={1}
              direction="row"
              spacing={1}
              flexWrap="wrap"
              alignItems="center"
            >
              {workGroupdetail?.wgcode ? (
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {workGroupdetail?.wgcode}-{workGroupdetail?.wgdesc}
                  &nbsp;/&nbsp;Asset Count:{workGroupdetail?.assetCount}
                </Typography>
              ) : (
                <Typography variant="h5" sx={{ flexGrow: 1 }}>
                  {rows?.length > 0 && (
                    <>All Assets &nbsp;/&nbsp;Asset Count:{assetTotalCount}</>
                  )}
                </Typography>
              )}
              {(isFems ? accessFem.canCreate : accessBem.canCreate) && <Button
                variant="contained"
                onClick={handleAssetRegister}
                sx={{ marginTop: { xs: 1, md: 2 } }}
                data-testid="AssetRegister"
              >
                {" "}
                ASSET REGISTER{" "}
              </Button>}

              {/* {/ Export button and refresh button /} */}
              <RefreshExportButtons
                exportFunction={handleExportData}
                exportData={exportData}
                rows={rows}
                refData={gridApi}
                handleRefresh={() => handleRefresh()}
                title={`Asset Register ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
              />
            </Stack>
          </Box>
          <CustomAgGrid
            refSet={gridApi}
            setGridApi={setGridApi}
            rows={filteredRows}
            columns={columnNames}
            handleDelete={
              (isFems ? accessFem.canDelete : accessBem.canDelete)
                ? (id) => handleDelete(id)
                : null
            }
            handleEdit={
              (isFems ? accessFem.canEdit : accessBem.canEdit)
                ? (id) => handleEdit(id, "Edit")
                : null
            }
            handleView={
              (isFems ? accessFem.canView : accessBem.canView)
                ? (id) => handleView(id, "View")
                : null
            }
            isLoading={gridLoader}
            //for pagination
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
          />
        </DefaultCard>
      </Box>
      <CloseButton />
      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        content="Are you sure you want to delete this asset?"
        cancelBtn="Cancel"
        confirmBtn="Delete"
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning !"
        content={errorMessage}
        cancelBtn="Cancel"
        confirmBtn="Ok"
      />
      <CustomAlert
        open={isError}
        onClose={() => setIsError(false)}
        onConfirm={() => setIsError(false)}
        content={"Something Went Wrong. Please try again later."}
        confirmBtn={"OK"}
      />
    </>
  );
};

export default AssetList;
